<template>
  <ReviewSection v-if="purchaseStore.hasPaymentData" :title="paymentSectionTitle" icon="wallet-payment-color">
    <template v-if="paymentRequired">
      <sp-col>
        <sp-subtitle>{{ displayPaymentName }}</sp-subtitle>
      </sp-col>
      <sp-col v-if="!hideReviewPaymentChange" cols="2" align-items="end">
        <sp-button variant="text-inline" @click="$emit('goto', 'payment')"> Change </sp-button>
      </sp-col>
    </template>
    <template v-else>
      <sp-col>
        <sp-subtitle> No payment required. </sp-subtitle>
      </sp-col>
    </template>

    <template #footer>
      <sp-row>
        <PaymentSummaryCol />
      </sp-row>
    </template>
  </ReviewSection>
</template>

<script setup>
import { computed, inject } from "vue";
import { usePurchaseStore } from "#ce/components/SpCheckout/store/purchase";
import PaymentSummaryCol from "./PaymentSummaryCol.ce.vue";
import ReviewSection from "./ReviewSection.ce.vue";
import { t } from "#ce/components/SpCheckout/i18n";

const purchaseStore = usePurchaseStore();

defineEmits(["goto"]);

defineProps({
  preamble: {
    type: String,
    default: "Review your data.",
  },
});

const paymentSectionTitle = computed(() => t("review_payment_section_title"));

const hideReviewPaymentChangeInjected = inject("spCheckoutHideReviewPaymentChange", null);
const hideReviewPaymentChange = computed(() =>
  hideReviewPaymentChangeInjected ? hideReviewPaymentChangeInjected.value : false,
);

const paymentRequired = computed(() => purchaseStore.paymentRequired.value);
const paymentName = computed(() => purchaseStore.paymentName.value);

const displayPaymentName = computed(() => {
  if (paymentName.value) {
    return paymentName.value;
  }

  return paymentRequired.value ? "Credit card" : "";
});
</script>
